import { render, staticRenderFns } from "./NrpPopup.vue?vue&type=template&id=87e5e11e&scoped=true"
import script from "./NrpPopup.vue?vue&type=script&lang=js"
export * from "./NrpPopup.vue?vue&type=script&lang=js"
import style0 from "./NrpPopup.vue?vue&type=style&index=0&id=87e5e11e&prod&lang=less&scoped=true"
import style1 from "./NrpPopup.vue?vue&type=style&index=1&id=87e5e11e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e5e11e",
  null
  
)

export default component.exports